import CONFIG from './src/config';
import './src/styles/index.scss';

const isIE = /MSIE|Trident/.test(window?.navigator.userAgent);
if (isIE && CONFIG.IE_WHITE_LIST.indexOf(window?.location.pathname) === -1) {
  window.location.replace(`/business/veralteter-browser.html`);
}

const standardWebmanifestLink = document.head.querySelectorAll(
  "[href='/manifest.webmanifest']"
);
if (standardWebmanifestLink.length) {
  const linkElement = standardWebmanifestLink[0];
  document.head.removeChild(linkElement);
}
